import { Radio, Text, VStack } from 'native-base';
import React, { ReactNode, useEffect, useState } from 'react';

import CPModal from 'app/components/CPModal';
import RadioButtonCard from 'app/components/RadioButtonCard';
import { tID } from 'app/services/TestHelper';

export type RadioChoiceDialogProps<T> = {
  title: string;
  isOpen: boolean;
  body?: string;
  children?: ReactNode;
  items: { value: T; title: string; body?: ReactNode }[];
  onClose: () => void;
  onChange: (value: string) => void;
};

export default function RadioChoiceDialog<T>({
  title,
  body,
  children,
  items,
  isOpen,
  onChange,
  onClose,
}: RadioChoiceDialogProps<T>) {
  const [selected, setSelected] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!isOpen) setTimeout(() => setSelected(undefined), 300);
  }, [isOpen]);

  return (
    <CPModal
      closeOnOverlayClick
      isOpen={isOpen}
      testID={tID('RadioChoiceDialog')}
      onClose={onClose}
    >
      <CPModal.Content>
        <CPModal.Header>{title}</CPModal.Header>
        <CPModal.Body>
          {body && <Text pb="4">{body}</Text>}
          {children}

          <Radio.Group aria-label="Choose an option" name="radiocChoiceOptionDialog" space="6">
            <VStack space="3" w="full">
              {items.map((item) => {
                const jsonValue = JSON.stringify(item.value);

                return (
                  <RadioButtonCard
                    key={jsonValue}
                    isSelected={selected === jsonValue}
                    testID={tID(`RadioChoiceDialogOption_${jsonValue}`)}
                    title={item.title}
                    value={jsonValue}
                    onPress={() => {
                      setSelected(jsonValue);
                      onChange(jsonValue);
                    }}
                  >
                    {item.body}
                  </RadioButtonCard>
                );
              })}
            </VStack>
          </Radio.Group>
        </CPModal.Body>
      </CPModal.Content>
    </CPModal>
  );
}
